// Deep-path import for SSR compatibility: vike evaluates this on the server
// via Node's ESM loader, which chokes on named imports from CommonJS `lodash`
// (`SyntaxError: [vite] Named export 'clamp' not found`). `lodash/clamp` is
// a pure default-export module, works in both SSR and client bundles.
import clamp from 'lodash/clamp'

export default function linearScale(
  domain: [number, number],
  range: [number, number],
  { clamp: clampResult = false }: { clamp?: boolean } = {}
) {
  return (value: number) => {
    if (domain[0] === domain[1] || range[0] === range[1]) {
      return range[0]
    }
    const ratio = (range[1] - range[0]) / (domain[1] - domain[0])
    const result = range[0] + ratio * (value - domain[0])
    return clampResult ? clamp(result, range[0], range[1]) : result
  }
}
